<template>
	<div>
		<v-row no-gutters v-if="!selectedMatter">
			<v-text-field
				label="案件を検索"
				dense
				outlined
				class="mt-2"
				hint="紐付けしたい案件の見積番号・受注番号を入力してください。"
				v-model="searchWord"
				@blur="searchMatters()"
			/>
			<v-btn class="ma-2 pa-2 mt-2" :disabled="!searchWord" color="primary" @click="searchMatters()"
				>検索</v-btn
			>
		</v-row>
		<v-row v-if="searchedMatters" align="center" justify="space-around" no-gutters>
			<p class="secondary--text" v-if="noMatterFlag">該当する案件データはありません</p>
			<v-btn
				height="auto"
				class="ma-2 pa-2"
				depressed
				v-for="matter in searchedMatters"
				:key="matter.id"
				@click="setMatter(matter)"
			>
				<div class="text-left">
					<p
						v-if="matter.name"
						class="pre-wrap"
						v-text="common.returnMatterInfoWithOrderNumber(matter)"
					></p>
				</div>
			</v-btn>
		</v-row>
		<v-card class="mx-auto my-2 selected-matter-card" v-if="selectedMatter">
			<v-card-text>
				<v-flex class="justify-space-between">
					<div class="">
						<p
							v-if="selectedMatter"
							class="pre-wrap"
							v-text="common.returnMatterInfoWithOrderNumber(selectedMatter)"
						></p>
					</div>
					<v-icon @click="removeMatter">mdi-close</v-icon>
				</v-flex>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"

function initialState() {
	return {
		rules: rules,
		common: common,
		searchWord: "",
		selectedMatter: null,
		searchedMatters: [],
		noMatterFlag: false,
	}
}

export default {
	props: {},
	components: {},
	data() {
		return initialState()
	},
	methods: {
		setMatter(matter) {
			this.selectedMatter = matter
			this.searchedMatters = []
			this.$emit("setParentMatterId", matter)
		},
		removeMatter() {
			this.selectedMatter = null
			this.$emit("unsetParentMatterId")
		},
		searchMatters() {
			if (this.searchWord) {
				this.noMatterFlag = false
				this.searchedMatters = []
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/matter_search.json", {
						headers,
						params: {
							q: { quotation_number_or_order_number_cont: this.searchWord },
							qq: { product_number_cont: this.searchWord },
						},
					})
					.then((response) => {
						this.searchedMatters = response.data.matters
						if (this.searchedMatters.length == 0) {
							this.noMatterFlag = true
						}
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			}
		},
	},
	watch: {},
	computed: {},
}
</script>
<style scoped>
.selected-matter-card {
	max-width: 320px;
}
</style>
